import React from 'react';
import { Link } from 'react-router-dom';

import { AutoComplete } from 'primereact/autocomplete';
import { Card } from 'primereact/card';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { InputSwitch } from 'primereact/inputswitch';

import useCompanionCase from 'modules/cases/hooks/useCompanionCase';
import PrimeReactDataTable from 'components/common/PrimeReactDataTable/PrimeReactDataTable';

export default function CompanionCases(props) {
  const { caseDetails } = props;
  const { loading, results, companionList, field, setField, searchAsync, createCompanion, deleteCompanion, updateAutomationStatus } =
    useCompanionCase(caseDetails?.case_id);
  const currentCaseName = caseDetails?.case_description?.case_name;
  const isLead = caseDetails?.is_lead ? caseDetails?.is_lead : false;

  const createLInk = () => {
    createCompanion(
      field?.map((v) => ({
        case_id: v?.case_id,
        case_point_of_contact:
          v?.case_description?.case_point_of_contact === undefined || v?.case_description?.case_point_of_contact === null
            ? true
            : v?.case_description?.case_point_of_contact,
      })),
      currentCaseName,
      isLead
    );
  };

  const confirmDelete = (case_id) => {
    confirmDialog({
      message: 'Are you sure want to delete this companion case?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept: () => deleteCompanion(case_id, currentCaseName),
    });
  };

  const columns = [
    {
      field: 'case_name',
      header: 'Companion Case',
      body: (rowData) => (
        <Link
          to={`/${rowData?.is_lead ? 'leads' : 'cases'}/${rowData?.case_id}`}
          className="a text-break pointer F-size14 call-back text-decoration-none w-100"
        >
          <span className="p-column-title">Companion Case</span>
          {rowData?.case_name}
        </Link>
      ),
      resizable: false,
    },
    {
      field: 'toggle',
      header: 'Send Automation Messages',
      body: (rowData) => (
        <div className="d-flex justify-content-center align-items-center">
          <span className="p-column-title">Send Automation Messages</span>
          <InputSwitch
            name={`toggle-${rowData?.case_id}`}
            checked={rowData?.case_point_of_contact != false}
            onChange={(e) => updateAutomationStatus(rowData?.case_id, e.value)}
          />
        </div>
      ),
      resizable: false,
      className: 'text-center waiting-payment-column',
      sortable: false,
    },
    {
      field: 'actions',
      header: 'Actions',
      body: (rowData) => (
        <span role="button">
          <span className="p-column-title">Delete</span>

          <i className="icon-delete ms-2" onClick={() => confirmDelete(rowData?.case_id)} id={`delete-${rowData?.case_id}`}>
            <Tooltip target={`#delete-${rowData?.case_id}`} position={'bottom'} className="case-tooltip mb-3" showDelay={500}>
              Delete
            </Tooltip>
          </i>
        </span>
      ),
      resizable: false,
      className: 'text-center needRes-action',
      sortable: false,
    },
  ];

  return (
    <>
      <div className="caption-bold mb-3">Companion Case</div>
      <Card className="card-bg F-size14 mb-3">
        <div className="row">
          <div className="d-flex align-items-top F-size14 flex-wrap">
            <div className="col-md-12 col-12 align-items-center edit-field">
              <div className="mb-3 d-flex align-items-end flex-column">
                <AutoComplete
                  placeholder="Search Existing Case"
                  style={{ width: '100%' }}
                  inputStyle={{ width: '100%' }}
                  completeMethod={searchAsync}
                  value={field}
                  multiple
                  suggestions={results}
                  loading={loading}
                  field="case_description.case_name"
                  onChange={(e) => setField(e.value)}
                  className="flex-grow-1 input-shadow"
                />
                <Button disabled={field?.length === 0} className="p-button p-button-secondary mt-2" onClick={createLInk}>
                  Link
                </Button>
              </div>
              <div className="mb-2">
                <PrimeReactDataTable
                  tableValues={companionList || []}
                  columnFields={columns}
                  isPaginated={false}
                  storageKey="companion_cases_table"
                  emptyMessage="No Companion Cases"
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}
